import { z } from 'zod'

/**
 * Schema for submitting/updating a book rating
 * - rating: 1-5 stars
 */
export const ratingSchema = z.object({
  rating: z
    .number()
    .int('Rating must be a whole number')
    .min(1, 'Rating must be at least 1')
    .max(5, 'Rating cannot exceed 5'),
})

/**
 * Schema for querying pulse data with pagination
 */
export const pulseQuerySchema = z.object({
  limit: z.coerce.number().min(1).max(50).default(10),
  page: z.coerce.number().min(1).default(1),
})

export type RatingInput = z.infer<typeof ratingSchema>
export type PulseQueryInput = z.infer<typeof pulseQuerySchema>
